import TokenManager from '../utils/storage/TokenManager';

export default api => {
    api.interceptors.request.use(
        async configs => {
            const token = await TokenManager.getAccessToken();

            if (token) {
                configs.headers = {
                    ...configs.headers,
                    Authorization: `Bearer ${token}`,
                };
            }

            return configs;
        },
        error => {
            console.error('API request error:', error.message, error.response?.data);
            return Promise.reject(error);
        },
    );
};
